// TODO: refactor this hook

import { useState } from 'react';
import type { AlertType } from '@/ui/components/Alert/Alert';
import useTranslations from '@/core/hooks/use-translations';
import useToast from '@/ui/components/Toast/useToast';
import extractErrorMessage from '@/ui/utils/errors/extract-error-message';

type SubmitAlert = {
  message: string;
  type: AlertType;
};

type SubmitHandlerOptions = {
  showToastOnError?: boolean;
  successMessage?: string;
  retryAction?: boolean;
};

const useSubmitHandler = <T>(
  handler?: (data: T) => Promise<void>,
  options: SubmitHandlerOptions = {},
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState<SubmitAlert | null>(null);
  const toast = useToast();
  const t = useTranslations();

  const { showToastOnError = true, successMessage } = options;

  const submit = async (data: T): Promise<boolean> => {
    if (!handler) return false;

    try {
      setIsLoading(true);
      setAlert(null);
      await handler(data);

      if (successMessage) {
        setAlert({
          message: successMessage,
          type: 'success',
        });
      }

      return true;
    } catch (err: unknown) {
      const finalErrorMessage = await extractErrorMessage(
        err,
        t('web_general_error_unknown'),
      );
      setAlert({
        message: finalErrorMessage,
        type: 'error',
      });

      if (showToastOnError) toast.error(finalErrorMessage);

      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, alert, submit };
};

export default useSubmitHandler;
